import { rootApi } from "../../api/rootApi";

export const adminRolesApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addAdminRole: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: `/admin/userRole/add`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
        body: params.data,
      }),
    }),
    getAllAdminRoles: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/userRole`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
      }),
    }),
    updateAdminRoleById: builder.mutation({
      query: (params) => ({
        method: "PATCH",
        url: `/admin/userRole/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
        body: params.data,
      }),
    }),
    deleteAdminRole: builder.mutation({
      query: (params) => ({
        method: "DELETE",
        url: `/admin/userRole/${params.id}`,
        headers: {
          Authorization: "Bearer " + params.token,
        },
      }),
    }),
  }),
});

export const {
  useAddAdminRoleMutation,
  useGetAllAdminRolesMutation,
  useUpdateAdminRoleByIdMutation,
  useDeleteAdminRoleMutation,
} = adminRolesApi;
